<div layout-fill layout="column" layout-align="center none">
    <div layout="row" layout-align="center none">
        <mat-card class="loggedOutCard" fxFlex.gt-md="25%" fxFlex.gt-xs="50%">
            <mat-card-header class="justifyContentCenter">
                <mat-card-title-group>
                    <!--<div mat-card-avatar class="loginAvatar">
                        <img src="./assets/jcuLogoBlue.jpg" alt="" height="40"/>
                    </div>-->
                    <div mat-card-avatar class="loginAvatar"><mat-icon matPrefix class="fontSize75" color="primary">account_circle</mat-icon></div>
                    <mat-card-title class="loginTitle">Sign In</mat-card-title>
                </mat-card-title-group>
            </mat-card-header>
            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <mat-card-content style="padding: 30px 0 10px 0 !important">
                    <div class="alternate-theme">
                        <button mat-raised-button color="primary" class="loginBtn" [disabled]="true || loginFormControls.username.value.trim().length > 0 || loginFormControls.password.value.trim().length > 0" type="button" (click)="windowsLogin()">Login with JCU Account</button>
                    </div>
                </mat-card-content>
                <h4 class="marginBottom0">&nbsp; OR &nbsp;</h4>
                <mat-card-content>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Email</mat-label>
                            <mat-icon matPrefix>person</mat-icon>
                            <input matInput placeholder="Email" formControlName="username" required (focus)="$event.target.select()">
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field class="full-width" appearance="outline">
                            <mat-label>Password</mat-label>
                            <mat-icon matPrefix>lock</mat-icon>
                            <input matInput placeholder="Password" type="password" formControlName="password" required [type]="hide ? 'password' : 'text'" (focus)="$event.target.select()">
                            <mat-icon matSuffix (click)="hide = !hide" class="showPasswordIcon">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </mat-form-field>
                    </div>
                </mat-card-content>
                <mat-card-actions>
                    <button mat-raised-button color="primary" class="loginBtn" [disabled]="loginForm.invalid">Login</button>
                    <a mat-button routerLink="/register" class="padding0 fontWeight400 verticalAlignMiddle">Create An Account</a>
                    <a mat-button routerLink="/forgotPassword" class="padding0 floatRight fontWeight400 verticalAlignMiddle">Forgot Password?</a>

                    <!--<mat-divider [inset]="true" class="btnDivider"></mat-divider>
                    <div class="alternate-theme paddingBottom16">
                        <button mat-raised-button color="primary" class="loginBtn" type="button" (click)="windowsLogin()">Login with JCU Account</button>
                    </div>-->
                </mat-card-actions>
            </form>
        </mat-card>
    </div>
    <!--<div layout="row" layout-align="center none">
        <div class="bottomText" fxFlex="70%" fxFlex.gt-md="25%">
            <p>Please use a desktop computer because this application is not yet optimized for mobile</p>
        </div>
    </div>-->
</div>
